import React from 'react';
import PropTypes from 'prop-types';

const EmbeddableTweet = ({ title, url, hideParent }) => {
  return (
    <section className="content-tweet">
      {title && (
        <header>
          <h3>{title}</h3>
        </header>
      )}
      <blockquote
        data-dnt={true}
        data-conversation={hideParent === 'true' ? 'none' : ''}
        className="twitter-tweet"
        data-lang="en"
      >
        <a href={url}></a> {/* eslint-disable-line */}
      </blockquote>
    </section>
  );
};

EmbeddableTweet.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
  hideParent: PropTypes.string
};

export default EmbeddableTweet;
